// extracted by mini-css-extract-plugin
export default {"confirm":"XzM4UIRYPA9QeJpO0Fkj","textContainer":"cUGCfUCxIBHP3MZw9ZKk","poweredByUnibuddy":"uNbEVakK7EO3pEeh47Bm"};